import * as wjcCore from '@grapecity/wijmo';
import * as wjMultirow from '@grapecity/wijmo.grid.multirow';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjInput from 'wijmo/wijmo.input';
import * as wjOlap from '@grapecity/wijmo.olap';
import * as moment from "moment";

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {asOrientDate, isOrientDate, DataService} from "@cosbeni/database";
import {ActivatedRoute} from "@angular/router";

declare var gapi;

@Component({
    selector: 'cj-user-analysis',
    templateUrl: 'analysis.component.html',
})

export class AnalysisComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('orderGrid') orderGrid: wjMultirow.MultiRow;
    @ViewChild('pivotGrid', {static: true}) pivotGrid: wjOlap.PivotGrid;
    @ViewChild('fromDateInput') fromDateInput: wjInput.InputDate;
    @ViewChild('toDateInput') toDateInput: wjInput.InputDate;
    fromDate: any;
    toDate: any;
    keyword: string = "";
    message: string = "";
    mode: string = "明細";
    report: string = "お問い合わせ実績";
    screenWidth: number;
    orders: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    pivot: wjOlap.PivotEngine;
    spreadsheetId: string = KaitoriyaConfig.production ? "1m4M_I_gUXy1Y4X35Sl8YBRDdT5hnUQyE_MkM6RXQ5CU" : "1Rzn4CI6FicE8iYEJ73twkrzFeNG9a4mFfCYnrK6daEU";

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute) {
        var today = new Date();
        this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    }

    ngAfterViewInit() {
    }

    search(): void {
        if (this.mode == "明細") {
            let where = [];
            if (!wjcCore.isNullOrWhiteSpace(this.keyword)) {
                where.push("header.name LIKE '%" + this.keyword + "%'");
                where.push("header.status LIKE '%" + this.keyword + "%'");
                where.push("header.finalStatus LIKE '%" + this.keyword + "%'");
                where.push("header.state LIKE '%" + this.keyword + "%'");
                where.push("header.city LIKE '%" + this.keyword + "%'");
                where.push("productName LIKE '%" + this.keyword + "%'");
                where.push("manufactureName LIKE '%" + this.keyword + "%'");
                where.push("modelNumber LIKE '%" + this.keyword + "%'");
            }
            if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
                where.push("(header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                where.push("(header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                where.push("(header.endDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.endDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            } else {
                if (wjcCore.isDate(this.fromDate)) {
                    where.push("header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("header.endDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                }
                if (wjcCore.isDate(this.toDate)) {
                    where.push("header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("header.endDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                }
            }
            this.dataService.query({
                sql: "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.estimateStaff as estimateStaff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,quantity,price,amount FROM AP_Order_Line WHERE " + where.join(" OR "),
                count: "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.estimateStaff as estimateStaff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,quantity,price,amount FROM AP_Order_Line WHERE " + where.join(" OR "),
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                let orders = [];
                for (let item of data.results) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '見積担当者': item.estimateStaff,
                        '都道府県': item.state,
                        '市区町村': item.city,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': item.productName,
                        'メーカー': item.manufactureName,
                        '型番': item.modelNumber,
                        '数量': item.quantity,
                        '単価': item.price,
                        '金額': item.amount,
                        '売仕': '仕入'
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    orders.push(order);
                }
                this.orders = new wjcCore.CollectionView(wjcCore.asArray(orders));
                this.pivot = new wjOlap.PivotEngine(
                    {
                        autoGenerateFields: false,
                        itemsSource: this.orders,
                        showRowTotals: wjOlap.ShowTotals.Subtotals,
                        fields: [
                            {binding: '番号', header: '番号'},
                            {binding: '枝番', header: '枝番'},
                            {binding: '名前', header: '名前'},
                            {binding: '買取区分', header: '買取区分'},
                            {binding: '最終区分', header: '最終区分'},
                            {binding: '部門', header: '部門'},
                            {binding: '担当者', header: '担当者'},
                            {binding: '見積担当者', header: '見積担当者'},
                            {binding: '都道府県', header: '都道府県'},
                            {binding: '市区町村', header: '市区町村'},
                            {binding: '受付日', header: '受付日'},
                            {binding: '買取開始日時', header: '買取開始日時'},
                            {binding: '買取終了日時', header: '買取終了日時'},
                            {binding: '商品名', header: '商品名'},
                            {binding: 'メーカー', header: 'メーカー'},
                            {binding: '型番', header: '型番'},
                            {binding: '数量', header: '数量', aggregate: 'Sum'},
                            {binding: '単価', header: '単価'},
                            {binding: '金額', header: '金額', aggregate: 'Sum'},
                            {binding: '売仕', header: '売仕'},
                        ],
                        columnFields: ['部門', '最終区分', '買取区分', '売仕'],
                        rowFields: ['買取開始日時'],
                        valueFields: ['金額']
                    }
                );
            })
        } else if (this.mode == "特殊") {
            this.orders = new wjcCore.CollectionView([]);
            let whereA = ["header.finalStatus='完了'"];
            let whereB = [];
            let whereC = [];
            let whereD = ["header.finalStatus='完了' AND (header.department='海外' OR header.department='海外（九州）')"];
            if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
                whereA.push("(header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                whereB.push("(startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                whereC.push("(orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                whereD.push("(header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            } else {
                if (wjcCore.isDate(this.fromDate)) {
                    whereA.push("header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereB.push("startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereC.push("orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereD.push("header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                }
                if (wjcCore.isDate(this.toDate)) {
                    whereA.push("header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereB.push("startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereC.push("orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    whereD.push("header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                }
            }
            let queryA = "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,oversea,quantity,price,amount FROM AP_Order_Line WHERE " + whereA.join(" AND ");
            let queryB = "SELECT id,branch,name,status,finalStatus,department,staff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + whereB.join(" AND ");
            let queryC = "SELECT id,branch,name,status,finalStatus,department,staff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + whereC.join(" AND ") + " ORDER BY startDate DESC";
            let queryD = "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,oversea,quantity,price,amount FROM AP_Order_Line WHERE " + whereD.join(" AND ");
            this.dataService.query({
                sql: queryA,
                count: queryA,
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                for (let item of data.results) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '都道府県': item.state,
                        '市区町村': item.city,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': item.productName,
                        'メーカー': item.manufactureName,
                        '型番': item.modelNumber,
                        '数量': item.quantity,
                        '単価': item.price,
                        '金額': item.amount,
                        '売仕': '仕入',
                        '日付': item.startDate,
                        '大分類': item.department,
                        '中分類': '3 買取金額',
                        '小分類': item.oversea,
                        '値': item.amount,
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    if (item.amount < 0) {
                        order['中分類'] = '4 回収売上';
                        order['値'] = order['値'] * -1;
                    }
                    if (item.department.indexOf('海外') >= 0) {
                        continue;
                    }
                    if (item.department.indexOf('海外') < 0 && item.oversea == "BB仕入") {
                        order['大分類'] = '海外';
                        order['中分類'] = '5 キャリー';
                        order['小分類'] = '';
                    }
                    this.orders.sourceCollection.push(order);
                }
                this.orders.refresh();
                this.pivot.itemsSource = this.orders;
            })
            this.dataService.query({
                sql: queryB,
                count: queryB,
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                let orderIds = {}
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                for (let item of data.results) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '都道府県': item.state,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': "",
                        'メーカー': "",
                        '型番': "",
                        '数量': 1,
                        '単価': item.total,
                        '金額': item.total,
                        '売仕': '仕入',
                        '日付': item.startDate,
                        '大分類': item.department,
                        '中分類': '1 見積',
                        '小分類': "",
                        '値': 1,
                    }
                    if (orderIds.hasOwnProperty(item.id) && orderIds[item.id].hasOwnProperty(wjcCore.Globalize.formatDate(item.startDate, 'yyyyMMdd'))) {
                        order['値'] = 0;
                    } else {
                        if (!orderIds.hasOwnProperty(item.id)) {
                            orderIds[item.id] = {};
                        }
                        orderIds[item.id][wjcCore.Globalize.formatDate(item.startDate, 'yyyyMMdd')] = 1;
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    if (item.finalStatus != 'キャンセル' && item.status != 'ｷｬﾝｾﾙ') {
                        if (item.department == 'キャリー') {
                            if (item.status == '見積' || item.status == '見積即' || item.status.indexOf('LINE') >= 0)
                                this.orders.sourceCollection.push(order);
                        } else {
                            this.orders.sourceCollection.push(order);
                        }
                    }
                    if (item.finalStatus == '完了') {
                        let orderSuccess = {...order};
                        orderSuccess['中分類'] = '2 成約';
                        this.orders.sourceCollection.push(orderSuccess);
                    }
                }
                this.orders.refresh();
                this.pivot.itemsSource = this.orders;
            })
            this.dataService.query({
                sql: queryC,
                count: queryC,
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                let orderIds = {};
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                for (let item of data.results) {
                    if (item.status.indexOf("見積") >= 0 || item.status.indexOf("トレ電話") >= 0 || item.status.indexOf("LINE") >= 0) {
                        let order = {
                            '番号': item.id,
                            '枝番': item.branch,
                            '名前': item.name,
                            '買取区分': item.status,
                            '最終区分': item.finalStatus,
                            '部門': item.department,
                            '担当者': item.staff,
                            '都道府県': item.state,
                            '受付日': item.orderDate,
                            '買取開始日時': item.startDate,
                            '買取終了日時': item.endDate,
                            '商品名': "",
                            'メーカー': "",
                            '型番': "",
                            '数量': 1,
                            '単価': item.total,
                            '金額': item.total,
                            '売仕': '仕入',
                            '日付': item.orderDate,
                            '大分類': '1 問合せ',
                            '中分類': item.state,
                            '小分類': "TEL+mail",
                            '値': 1,
                        }
                        if (orderIds.hasOwnProperty(item.id)) {
                            order['値'] = 0;
                        } else {
                            orderIds[item.id] = 1;
                        }
                        if (item.amount < 0) {
                            order['売仕'] = '売上';
                        }
                        if (item.state.indexOf("兵庫") >= 0) {
                            order['中分類'] = '兵庫';
                        }
                        if (item.state.indexOf("大阪") >= 0) {
                            order['中分類'] = '大阪';
                        }
                        if (item.status.indexOf("トレ電話") >= 0) {
                            order['中分類'] = 'トレ';
                        }
                        if (item.status.indexOf("LINE") >= 0) {
                            order['中分類'] = 'LINE';
                        }
                        if (order['中分類'] != '兵庫' && order['中分類'] != '大阪' && order['中分類'] != 'トレ' && order['中分類'] != 'LINE') {
                            order['中分類'] = 'その他';
                        }
                        this.orders.sourceCollection.push(order);
                        if (!wjcCore.isNullOrWhiteSpace(item.startDate)) {
                            let orderSuccess = {...order};
                            orderSuccess['小分類'] = '決定';
                            this.orders.sourceCollection.push(orderSuccess);
                        }
                    }
                }
                this.orders.refresh();
                this.pivot.itemsSource = this.orders;
            })
            this.dataService.query({
                sql: queryD,
                count: queryD,
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                for (let item of data.results) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '都道府県': item.state,
                        '市区町村': item.city,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': item.productName,
                        'メーカー': item.manufactureName,
                        '型番': item.modelNumber,
                        '数量': item.quantity,
                        '単価': item.price,
                        '金額': item.amount,
                        '売仕': '仕入',
                        '日付': item.orderDate,
                        '大分類': item.department,
                        '中分類': '3 買取金額',
                        '小分類': item.oversea,
                        '値': item.amount,
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    if (item.amount < 0) {
                        order['中分類'] = '4 回収売上';
                        order['値'] = order['値'] * -1;
                    }
                    if (item.department.indexOf('海外') >= 0) {
                        order['大分類'] = '海外';
                        if(item.department == "海外"){
                            order['中分類'] = '3 BB仕入';
                        } else if(item.department == "海外（九州）"){
                            order['中分類'] = '4 BB仕入:九州';
                        }
                    }
                    if (item.department.indexOf('海外') < 0 && item.oversea == "BB仕入") {
                        order['大分類'] = '海外';
                        order['中分類'] = '5 キャリー';
                        order['小分類'] = '';
                    }
                    this.orders.sourceCollection.push(order);
                }
                this.orders.refresh();
                this.pivot.itemsSource = this.orders;
            })
            this.pivot = new wjOlap.PivotEngine(
                {
                    autoGenerateFields: false,
                    itemsSource: this.orders,
                    showColumnTotals: wjOlap.ShowTotals.None,
                    showRowTotals: wjOlap.ShowTotals.Subtotals,
                    fields: [
                        {binding: '番号', header: '番号'},
                        {binding: '枝番', header: '枝番'},
                        {binding: '名前', header: '名前'},
                        {binding: '買取区分', header: '買取区分'},
                        {binding: '最終区分', header: '最終区分'},
                        {binding: '部門', header: '部門'},
                        {binding: '担当者', header: '担当者'},
                        {binding: '都道府県', header: '都道府県'},
                        {binding: '受付日', header: '受付日'},
                        {binding: '買取開始日時', header: '買取開始日時'},
                        {binding: '買取終了日時', header: '買取終了日時'},
                        {binding: '商品名', header: '商品名'},
                        {binding: 'メーカー', header: 'メーカー'},
                        {binding: '型番', header: '型番'},
                        {binding: '数量', header: '数量', aggregate: 'Sum'},
                        {binding: '単価', header: '単価'},
                        {binding: '金額', header: '金額', aggregate: 'Sum'},
                        {binding: '売仕', header: '売仕'},
                        {binding: '日付', header: '日付'},
                        {binding: '大分類', header: '大分類'},
                        {binding: '中分類', header: '中分類'},
                        {binding: '小分類', header: '小分類'},
                        {binding: '値', header: '値', aggregate: 'Sum'},
                    ],
                    columnFields: ['大分類', '中分類', '小分類'],
                    rowFields: ['日付'],
                    valueFields: ['値']
                }
            );
        } else {
            let where = [];
            if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
                where.push("(orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                where.push("(startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
                where.push("(endDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND endDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            } else {
                if (wjcCore.isDate(this.fromDate)) {
                    where.push("orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("endDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                }
                if (wjcCore.isDate(this.toDate)) {
                    where.push("orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                    where.push("endDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                }
            }
            this.dataService.query({
                sql: "SELECT id,branch,name,status,finalStatus,department,staff,estimateStaff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + where.join(" OR "),
                count: "SELECT id,branch,name,status,finalStatus,department,staff,estimateStaff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + where.join(" OR "),
                fetchPlan: "*:1",
            }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
                for (let item of data.results) {
                    if (isOrientDate(item.orderDate)) {
                        item.orderDate = asOrientDate(item.orderDate);
                    }
                    if (isOrientDate(item.startDate)) {
                        item.startDate = asOrientDate(item.startDate);
                    }
                    if (isOrientDate(item.endDate)) {
                        item.endDate = asOrientDate(item.endDate);
                    }
                }
                let orders = [];
                for (let item of data.results) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '見積担当者': item.estimateStaff,
                        '都道府県': item.state,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': "",
                        'メーカー': "",
                        '型番': "",
                        '数量': 1,
                        '単価': item.total,
                        '金額': item.total,
                        '売仕': '仕入'
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    orders.push(order);
                }
                this.orders = new wjcCore.CollectionView(wjcCore.asArray(orders));
                this.pivot = new wjOlap.PivotEngine(
                    {
                        autoGenerateFields: false,
                        itemsSource: this.orders,
                        showRowTotals: wjOlap.ShowTotals.Subtotals,
                        fields: [
                            {binding: '番号', header: '番号'},
                            {binding: '枝番', header: '枝番'},
                            {binding: '名前', header: '名前'},
                            {binding: '買取区分', header: '買取区分'},
                            {binding: '最終区分', header: '最終区分'},
                            {binding: '部門', header: '部門'},
                            {binding: '担当者', header: '担当者'},
                            {binding: '見積担当者', header: '見積担当者'},
                            {binding: '都道府県', header: '都道府県'},
                            {binding: '受付日', header: '受付日'},
                            {binding: '買取開始日時', header: '買取開始日時'},
                            {binding: '買取終了日時', header: '買取終了日時'},
                            {binding: '商品名', header: '商品名'},
                            {binding: 'メーカー', header: 'メーカー'},
                            {binding: '型番', header: '型番'},
                            {binding: '数量', header: '数量', aggregate: 'Sum'},
                            {binding: '単価', header: '単価'},
                            {binding: '金額', header: '金額', aggregate: 'Sum'},
                            {binding: '売仕', header: '売仕'},
                        ],
                        columnFields: ['部門', '最終区分', '買取区分'],
                        rowFields: ['買取開始日時'],
                        valueFields: ['金額']
                    }
                );
            })
        }
    }

    onChangeFromDate(): void {
        this.toDateInput.min = this.fromDate;
    }

    export(grid: string, name: string) {
        wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this[grid], {
            includeColumnHeaders: true,
            includeRowHeaders: true,
            includeCellStyles: false
        }, name + '.xlsx');
    }

    getDateSerial(dt: Date): any {
        const dateSerial: number = 25569.0 + ((dt.getTime() - (dt.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
        return dateSerial.toString().substr(0, 5)
    }

    updateSpreadsheet() {
        let inquiryData = {};
        let buyingCountData = {};
        let buyingAmountData = {};
        let buyingOverseaAmountData = {};
        let orders = new wjcCore.CollectionView([]);
        let whereA = ["header.finalStatus='完了'"];
        let whereB = [];
        let whereC = [];
        let whereD = ["header.finalStatus='完了' AND (header.department='海外' OR header.department='海外（九州）')"];
        if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
            whereA.push("(header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            whereB.push("(startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            whereC.push("(orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
            whereD.push("(header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
        } else {
            if (wjcCore.isDate(this.fromDate)) {
                whereA.push("header.startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                whereB.push("startDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                whereC.push("orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
                whereD.push("header.orderDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
            }
            if (wjcCore.isDate(this.toDate)) {
                whereA.push("header.startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                whereB.push("startDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                whereC.push("orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
                whereD.push("header.orderDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
            }
        }
        if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate) && this.fromDate.getDate() <= this.toDate.getDate()) {
            for (let d = this.fromDate; d <= this.toDate; d = wjcCore.DateTime.addDays(d, 1)) {
                buyingAmountData[wjcCore.Globalize.formatDate(d, 'dd')] = {};
                buyingAmountData[wjcCore.Globalize.formatDate(d, 'dd')]['キャリー'] = {"買取金額": 0, "回収売上": 0};
                buyingAmountData[wjcCore.Globalize.formatDate(d, 'dd')]['キャリーT'] = {"買取金額": 0, "回収売上": 0};
                buyingAmountData[wjcCore.Globalize.formatDate(d, 'dd')]['海外'] = {"買取金額": 0, "回収売上": 0};
                buyingCountData[wjcCore.Globalize.formatDate(d, 'dd')] = {};
                buyingCountData[wjcCore.Globalize.formatDate(d, 'dd')]['キャリー'] = {"見積": 0, "成約": 0};
                buyingCountData[wjcCore.Globalize.formatDate(d, 'dd')]['キャリーT'] = {"見積": 0, "成約": 0};
                inquiryData[wjcCore.Globalize.formatDate(d, 'dd')] = {"大阪TEL+mail": 0, "大阪決定": 0, "兵庫TEL+mail": 0, "兵庫決定": 0, "LINETEL+mail": 0, "LINE決定": 0, "トレTEL+mail": 0, "トレ決定": 0};
                buyingOverseaAmountData[wjcCore.Globalize.formatDate(d, 'dd')] = {};
                buyingOverseaAmountData[wjcCore.Globalize.formatDate(d, 'dd')]['海外'] = {"買取金額": 0, "回収売上": 0};
                buyingOverseaAmountData[wjcCore.Globalize.formatDate(d, 'dd')]['海外（九州）'] = {"買取金額": 0, "回収売上": 0};
            }
        }

        let queryA = "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,oversea,quantity,price,amount FROM AP_Order_Line WHERE " + whereA.join(" AND ");
        let queryB = "SELECT id,branch,name,status,finalStatus,department,staff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + whereB.join(" AND ");
        let queryC = "SELECT id,branch,name,status,finalStatus,department,staff,state,city,orderDate,startDate,endDate,total FROM AP_Order_Head WHERE " + whereC.join(" AND ") + " ORDER BY startDate DESC";
        let queryD = "SELECT header.id as id,header.branch as branch,header.name as name,header.status as status,header.finalStatus as finalStatus,header.department as department,header.staff as staff,header.state as state,header.city as city ,header.orderDate as orderDate,header.startDate as startDate,header.endDate as endDate,productName,manufactureName,modelNumber,oversea,quantity,price,amount FROM AP_Order_Line WHERE " + whereD.join(" AND ");
        this.dataService.query({
            sql: queryA,
            count: queryA,
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            let spreadSheetData = [];
            for (let item of data.results) {
                if (isOrientDate(item.orderDate)) {
                    item.orderDate = asOrientDate(item.orderDate);
                }
                if (isOrientDate(item.startDate)) {
                    item.startDate = asOrientDate(item.startDate);
                }
                if (isOrientDate(item.endDate)) {
                    item.endDate = asOrientDate(item.endDate);
                }
            }
            for (let item of data.results) {
                let order = {
                    '番号': item.id,
                    '枝番': item.branch,
                    '名前': item.name,
                    '買取区分': item.status,
                    '最終区分': item.finalStatus,
                    '部門': item.department,
                    '担当者': item.staff,
                    '都道府県': item.state,
                    '市区町村': item.city,
                    '受付日': item.orderDate,
                    '買取開始日時': item.startDate,
                    '買取終了日時': item.endDate,
                    '商品名': item.productName,
                    'メーカー': item.manufactureName,
                    '型番': item.modelNumber,
                    '数量': item.quantity,
                    '単価': item.price,
                    '金額': item.amount,
                    '売仕': '仕入',
                    '日付': item.startDate,
                    '大分類': item.department,
                    '中分類': '買取金額',
                    '小分類': '',
                    '値': item.amount,
                }
                if (item.amount < 0) {
                    order['売仕'] = '売上';
                }
                if (item.amount < 0) {
                    order['中分類'] = '回収売上';
                    order['値'] = order['値'] * -1;
                }
                if (item.department.indexOf('海外') >= 0) {
                    continue;
                }
                if (item.department.indexOf('海外') < 0 && item.oversea == "BB仕入") {
                    order['大分類'] = '海外';
                    order['中分類'] = '買取金額';
                    order['小分類'] = '';
                }
                if (!buyingAmountData.hasOwnProperty(wjcCore.Globalize.formatDate(order['日付'], 'dd'))) {
                    buyingAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')] = {};
                }
                if (!buyingAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')].hasOwnProperty(order['大分類'])) {
                    buyingAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']] = {
                        "買取金額": 0,
                        "回収売上": 0
                    };
                }
                if (wjcCore.isNumber(order['値'])) {
                    buyingAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']][order['中分類']] = buyingAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']][order['中分類']] + order['値'];
                }
                orders.sourceCollection.push(order);
            }
            for (let day in buyingAmountData) {
                let row = Number(day) + 4;
                for (let key in buyingAmountData[day]) {
                    if (key == "キャリー") {
                        if(this.fromDate < new Date(2022,0,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!M" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!O" + row,
                                values: [[buyingAmountData[day][key]["回収売上"]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!O" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!Q" + row,
                                values: [[buyingAmountData[day][key]["回収売上"]]]
                            })
                        }
                    }
                    if (key == "キャリーT") {
                        if(this.fromDate < new Date(2022,0,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!S" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!U" + row,
                                values: [[buyingAmountData[day][key]["回収売上"]]]
                            })
                        } else if(this.fromDate < new Date(2026,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!U" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!W" + row,
                                values: [[buyingAmountData[day][key]["回収売上"]]]
                            })
                        }
                    }
                    if (key == "海外") {
                        if(this.fromDate < new Date(2021,10,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AF" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                        } else if(this.fromDate < new Date(2022,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AG" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                        } else if(this.fromDate < new Date(2022,3,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AI" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AJ" + row,
                                values: [[buyingAmountData[day][key]["買取金額"]]]
                            })
                        }
                    }
                }
            }
            gapi.client.sheets.spreadsheets.values.batchUpdate({
                spreadsheetId: this.spreadsheetId,
            }, {
                valueInputOption: 'USER_ENTERED',
                data: spreadSheetData
            }).then((response) => {
                console.log(response.result);
            });
        })

        this.dataService.query({
            sql: queryB,
            count: queryB,
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            let spreadSheetData = [];
            let orderIds = {}
            for (let item of data.results) {
                if (isOrientDate(item.orderDate)) {
                    item.orderDate = asOrientDate(item.orderDate);
                }
                if (isOrientDate(item.startDate)) {
                    item.startDate = asOrientDate(item.startDate);
                }
                if (isOrientDate(item.endDate)) {
                    item.endDate = asOrientDate(item.endDate);
                }
            }
            for (let item of data.results) {
                let order = {
                    '番号': item.id,
                    '枝番': item.branch,
                    '名前': item.name,
                    '買取区分': item.status,
                    '最終区分': item.finalStatus,
                    '部門': item.department,
                    '担当者': item.staff,
                    '都道府県': item.state,
                    '受付日': item.orderDate,
                    '買取開始日時': item.startDate,
                    '買取終了日時': item.endDate,
                    '商品名': "",
                    'メーカー': "",
                    '型番': "",
                    '数量': 1,
                    '単価': item.total,
                    '金額': item.total,
                    '売仕': '仕入',
                    '日付': item.startDate,
                    '大分類': item.department,
                    '中分類': '1 見積',
                    '小分類': "",
                    '値': 1,
                }
                if (orderIds.hasOwnProperty(item.id) && orderIds[item.id].hasOwnProperty(wjcCore.Globalize.formatDate(item.startDate, 'yyyyMMdd'))) {
                    order['値'] = 0;
                } else {
                    if (!orderIds.hasOwnProperty(item.id)) {
                        orderIds[item.id] = {};
                    }
                    orderIds[item.id][wjcCore.Globalize.formatDate(item.startDate, 'yyyyMMdd')] = 1;
                }
                if (!buyingCountData.hasOwnProperty(wjcCore.Globalize.formatDate(order['日付'], 'dd'))) {
                    buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')] = {};
                }
                if (!buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')].hasOwnProperty(order['大分類'])) {
                    buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']] = {
                        "見積": 0,
                        "成約": 0
                    };
                }
                if (item.amount < 0) {
                    order['売仕'] = '売上';
                }
                if (item.finalStatus != 'キャンセル' && item.status != 'ｷｬﾝｾﾙ') {
                    if (item.department == 'キャリー') {
                        if (item.status == '見積' || item.status == '見積即'|| item.status.indexOf('LINE') >= 0)
                            buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["見積"] = buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["見積"] + order['値'];
                        this.orders.sourceCollection.push(order);
                    } else {
                        buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["見積"] = buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["見積"] + order['値'];
                        this.orders.sourceCollection.push(order);
                    }
                }
                if (item.finalStatus == '完了') {
                    let orderSuccess = {...order};
                    orderSuccess['中分類'] = '2 成約';
                    buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["成約"] = buyingCountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']]["成約"] + order['値'];
                    orders.sourceCollection.push(orderSuccess);
                }
            }
            for (let day in buyingCountData) {
                let row = Number(day) + 4;
                for (let key in buyingCountData[day]) {
                    if (key == "キャリー") {
                        if(this.fromDate < new Date(2022,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!K" + row,
                                values: [[buyingCountData[day][key]["見積"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!L" + row,
                                values: [[buyingCountData[day][key]["成約"]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!M" + row,
                                values: [[buyingCountData[day][key]["見積"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!N" + row,
                                values: [[buyingCountData[day][key]["成約"]]]
                            })
                        }
                    }
                    if (key == "キャリーT") {
                        if(this.fromDate < new Date(2022,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!Q" + row,
                                values: [[buyingCountData[day][key]["見積"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!R" + row,
                                values: [[buyingCountData[day][key]["成約"]]]
                            })
                        } else if(this.fromDate < new Date(2026,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!S" + row,
                                values: [[buyingCountData[day][key]["見積"]]]
                            })
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!T" + row,
                                values: [[buyingCountData[day][key]["成約"]]]
                            })
                        }
                    }
                }
            }
            gapi.client.sheets.spreadsheets.values.batchUpdate({
                spreadsheetId: this.spreadsheetId,
            }, {
                valueInputOption: 'USER_ENTERED',
                data: spreadSheetData
            }).then((response) => {
                console.log(response.result);
            });
        })

        this.dataService.query({
            sql: queryC,
            count: queryC,
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            let spreadSheetData = [];
            let orderIds = {};
            for (let item of data.results) {
                if (isOrientDate(item.orderDate)) {
                    item.orderDate = asOrientDate(item.orderDate);
                }
                if (isOrientDate(item.startDate)) {
                    item.startDate = asOrientDate(item.startDate);
                }
                if (isOrientDate(item.endDate)) {
                    item.endDate = asOrientDate(item.endDate);
                }
            }
            for (let item of data.results) {
                if (item.status.indexOf("見積") >= 0 || item.status.indexOf("トレ電話") >= 0 || item.status.indexOf("LINE") >= 0) {
                    let order = {
                        '番号': item.id,
                        '枝番': item.branch,
                        '名前': item.name,
                        '買取区分': item.status,
                        '最終区分': item.finalStatus,
                        '部門': item.department,
                        '担当者': item.staff,
                        '都道府県': item.state,
                        '受付日': item.orderDate,
                        '買取開始日時': item.startDate,
                        '買取終了日時': item.endDate,
                        '商品名': "",
                        'メーカー': "",
                        '型番': "",
                        '数量': 1,
                        '単価': item.total,
                        '金額': item.total,
                        '売仕': '仕入',
                        '日付': item.orderDate,
                        '大分類': '1 問合せ',
                        '中分類': item.state,
                        '小分類': "TEL+mail",
                        '値': 1,
                    }
                    if (orderIds.hasOwnProperty(item.id)) {
                        order['値'] = 0;
                    } else {
                        orderIds[item.id] = 1;
                    }
                    if (item.amount < 0) {
                        order['売仕'] = '売上';
                    }
                    if (item.status.indexOf("LINE") >= 0) {
                        order['中分類'] = 'LINE';
                    }
                    if (item.status.indexOf("トレ電話") >= 0) {
                        order['中分類'] = 'トレ';
                    }
                    if (!inquiryData.hasOwnProperty(wjcCore.Globalize.formatDate(order['日付'], 'dd'))) {
                        inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')] = {
                            "大阪TEL+mail": 0,
                            "大阪決定": 0,
                            "兵庫TEL+mail": 0,
                            "兵庫決定": 0,
                            "LINETEL+mail": 0,
                            "LINE決定": 0,
                            "トレTEL+mail": 0,
                            "トレ決定": 0,
                        };
                    }
                    if (order['中分類'].indexOf("大阪") >= 0) {
                        inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["大阪TEL+mail"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["大阪TEL+mail"] + order['値'];
                    }
                    if (order['中分類'].indexOf("兵庫") >= 0) {
                        inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["兵庫TEL+mail"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["兵庫TEL+mail"] + order['値'];
                    }
                    if (order['中分類'].indexOf("LINE") >= 0) {
                        inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["LINETEL+mail"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["LINETEL+mail"] + order['値'];
                    }
                    if (order['中分類'].indexOf("トレ") >= 0) {
                        inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["トレTEL+mail"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["トレTEL+mail"] + order['値'];
                    }
                    orders.sourceCollection.push(order);
                    if (!wjcCore.isNullOrWhiteSpace(item.startDate)) {
                        let orderSuccess = {...order};
                        orderSuccess['小分類'] = '決定';
                        if (order['中分類'].indexOf("大阪") >= 0) {
                            inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["大阪決定"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["大阪決定"] + order['値'];
                        }
                        if (order['中分類'].indexOf("兵庫") >= 0) {
                            inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["兵庫決定"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["兵庫決定"] + order['値'];
                        }
                        if (order['中分類'].indexOf("LINE") >= 0) {
                            inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["LINE決定"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["LINE決定"] + order['値'];
                        }
                        if (order['中分類'].indexOf("トレ") >= 0) {
                            inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["トレ決定"] = inquiryData[wjcCore.Globalize.formatDate(order['日付'], 'dd')]["トレ決定"] + order['値'];
                        }
                        orders.sourceCollection.push(orderSuccess);
                    }
                }
            }
            for (let day in inquiryData) {
                let row = Number(day) + 4;
                for (let key in inquiryData[day]) {
                    if (key == "兵庫TEL+mail") {
                        spreadSheetData.push({
                            range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!C" + row,
                            values: [[inquiryData[day][key]]]
                        })
                    }
                    if (key == "兵庫決定") {
                        spreadSheetData.push({
                            range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!D" + row,
                            values: [[inquiryData[day][key]]]
                        })
                    }
                    if (key == "大阪TEL+mail") {
                        spreadSheetData.push({
                            range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!E" + row,
                            values: [[inquiryData[day][key]]]
                        })
                    }
                    if (key == "大阪決定") {
                        spreadSheetData.push({
                            range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!F" + row,
                            values: [[inquiryData[day][key]]]
                        })
                    }
                    if (key == "LINETEL+mail") {
                        if(this.fromDate < new Date(2022,0,1)){
                           ;
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!G" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        }
                    }
                    if (key == "LINE決定") {
                        if(this.fromDate < new Date(2022,0,1)){
                            ;
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!H" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        }
                    }
                    if (key == "トレTEL+mail") {
                        if(this.fromDate < new Date(2022,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!I" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!K" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        }

                    }
                    if (key == "トレ決定") {
                        if(this.fromDate < new Date(2022,0,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!J" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!L" + row,
                                values: [[inquiryData[day][key]]]
                            })
                        }
                    }
                }
            }
            gapi.client.sheets.spreadsheets.values.batchUpdate({
                spreadsheetId: this.spreadsheetId,
            }, {
                valueInputOption: 'USER_ENTERED',
                data: spreadSheetData
            }).then((response) => {
                console.log(response.result);
            });
        })

        this.dataService.query({
            sql: queryD,
            count: queryD,
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            let spreadSheetData = [];
            for (let item of data.results) {
                if (isOrientDate(item.orderDate)) {
                    item.orderDate = asOrientDate(item.orderDate);
                }
                if (isOrientDate(item.startDate)) {
                    item.startDate = asOrientDate(item.startDate);
                }
                if (isOrientDate(item.endDate)) {
                    item.endDate = asOrientDate(item.endDate);
                }
            }
            for (let item of data.results) {
                let order = {
                    '番号': item.id,
                    '枝番': item.branch,
                    '名前': item.name,
                    '買取区分': item.status,
                    '最終区分': item.finalStatus,
                    '部門': item.department,
                    '担当者': item.staff,
                    '都道府県': item.state,
                    '市区町村': item.city,
                    '受付日': item.orderDate,
                    '買取開始日時': item.startDate,
                    '買取終了日時': item.endDate,
                    '商品名': item.productName,
                    'メーカー': item.manufactureName,
                    '型番': item.modelNumber,
                    '数量': item.quantity,
                    '単価': item.price,
                    '金額': item.amount,
                    '売仕': '仕入',
                    '日付': item.orderDate,
                    '大分類': item.department,
                    '中分類': '買取金額',
                    '小分類': '',
                    '値': item.amount,
                }
                if (item.amount < 0) {
                    order['売仕'] = '売上';
                }
                if (item.amount < 0) {
                    order['中分類'] = '回収売上';
                    order['値'] = order['値'] * -1;
                }
                if (item.department.indexOf('海外') >= 0) {
                    order['中分類'] = '買取金額';
                }
                if (!buyingOverseaAmountData.hasOwnProperty(wjcCore.Globalize.formatDate(order['日付'], 'dd'))) {
                    buyingOverseaAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')] = {};
                }
                if (!buyingOverseaAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')].hasOwnProperty(order['大分類'])) {
                    buyingOverseaAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']] = {
                        "買取金額": 0,
                        "回収売上": 0
                    };
                }
                if (wjcCore.isNumber(order['値'])) {
                    buyingOverseaAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']][order['中分類']] = buyingOverseaAmountData[wjcCore.Globalize.formatDate(order['日付'], 'dd')][order['大分類']][order['中分類']] + order['値'];
                }
                orders.sourceCollection.push(order);
            }
            for (let day in buyingOverseaAmountData) {
                let row = Number(day) + 4;
                for (let key in buyingOverseaAmountData[day]) {
                    if (key == "海外") {
                        if(this.fromDate < new Date(2021,10,1)){
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AD" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        } else if(this.fromDate < new Date(2022,0,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AC" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        } else if(this.fromDate < new Date(2022,3,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AE" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AH" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        }
                    }
                    if (key == "海外（九州）") {
                        if(this.fromDate < new Date(2021,10,1)){
                            ;
                        } else if(this.fromDate < new Date(2022,0,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AD" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        } else if(this.fromDate < new Date(2022,3,1)) {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AF" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        } else {
                            spreadSheetData.push({
                                range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!AK" + row,
                                values: [[buyingOverseaAmountData[day][key]["買取金額"]]]
                            })
                        }
                    }
                }
            }
            gapi.client.sheets.spreadsheets.values.batchUpdate({
                spreadsheetId: this.spreadsheetId,
            }, {
                valueInputOption: 'USER_ENTERED',
                data: spreadSheetData
            }).then((response) => {
                console.log(response.result);
            });
        })
    }

    /*
    updateSpreadsheet() {
        console.log(this.pivotGrid);
        this.toDateInput.min = this.fromDate;
        gapi.client.sheets.spreadsheets.values.get({
            spreadsheetId: this.spreadsheetId,
            range: wjcCore.Globalize.formatDate(this.fromDate, 'yyyyMM') + "!A1:AZ100",
            valueRenderOption: 'FORMULA'
        }).then((response) => {
            let columns = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
            columns.push(...["AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ"]);
            let columnValues: any = {};
            for (let c of columns) {
                columnValues[c] = [];
            }
            let values = [];
            for (let items of response.result.values) {
                let rowValues = [];
                let previousValue = ""
                let index = 0;
                for (let c of columns) {
                    if (!wjcCore.isNullOrWhiteSpace(items[index])) {
                        if (wjcCore.isString(items[index])) {
                            let v: string = items[index]
                            v = v.replace(/\n/g, "");
                            v = v.replace(/\t/g, "");
                            items[index] = v;
                        }
                        rowValues.push(items[index]);
                        columnValues[c].push(items[index]);
                        previousValue = items[index];
                    } else {
                        rowValues.push(previousValue);
                        columnValues[columns[index]].push(previousValue);
                    }
                    index = index + 1;
                }
                values.push(rowValues);
            }
            console.log(columnValues);
        });
        gapi.client.sheets.spreadsheets.values.batchUpdate({
            spreadsheetId: this.spreadsheetId,
        }, {
            valueInputOption: 'USER_ENTERED',
            data: [{
                range: "Sheet1!A1",
                values: [[1]]
            }, {
                range: "Sheet1!A5",
                values: [["A5"]]
            }]
        }).then((response) => {
            console.log(response.result);
        });
    }
    */
}

